// AUTO SELECT SUBSCRIPTION OPTION ON PAGE LOAD AND OTHER CHANGES

let hasDefaulted = false;
let userInteracted = false;

function selectSubscribeByDefault() {
  if (hasDefaulted || userInteracted) return;

  const subscribeRadio = document.querySelector(
    'input.sls-option[data-type="subscription"]'
  );

  if (subscribeRadio) {
    subscribeRadio.click();
    hasDefaulted = true;
    // shared observer stops calling this once hasDefaulted is true
  }
}

// Mark as "user interacted" the moment they click ANY option manually
document.addEventListener('click', (e) => {
  if (e.target.matches('input.sls-option')) {
    userInteracted = true;
  }
});

window.addEventListener('DOMContentLoaded', () => {
  setTimeout(selectSubscribeByDefault, 300);
});

// (observer moved to the single shared observer at the bottom of this file)


// CHANGE THE LABEL FOR THE ONE TIME AND SUBSCRIPTION

function renameSubscriptionLabels() {
  // PDP widget (main product form) -> "Auto-Replenish"
  document.querySelectorAll('.sealsubs-target-element:not(.sticky-atc) .sls-selling-plan-group-name').forEach(el => {
    el.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        const trimmed = node.textContent.trim();
        if (trimmed === 'Subscribe' || trimmed === 'Auto-Replenish') {
          if (node.textContent !== 'Auto-Replenish') node.textContent = 'Auto-Replenish';
        }
      }
    });
  });

  // Sticky ATC widget -> "Subscribe to Save 15%"
  document.querySelectorAll('.sealsubs-target-element.sticky-atc .sls-selling-plan-group-name').forEach(el => {
    el.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        const trimmed = node.textContent.trim();
        if (trimmed === 'Subscribe' || trimmed === 'Auto-Replenish') {
          if (node.textContent !== 'Subscribe to Save 15%') node.textContent = 'Subscribe to Save 15%';
        }
      }
    });
  });

  // BOTH widgets -> "One-time purchase" becomes "Buy Once"
  document.querySelectorAll('.sealsubs-target-element label').forEach(el => {
    el.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        const trimmed = node.textContent.trim();
        if (trimmed === 'One-time purchase' || trimmed === 'Buy Once') {
          if (node.textContent !== 'Buy Once') node.textContent = 'Buy Once';
        }
      }
    });
  });
}

let labelDebounce;
function scheduleLabelRename() {
  clearTimeout(labelDebounce);
  labelDebounce = setTimeout(renameSubscriptionLabels, 150);
}

scheduleLabelRename();

// (observer moved to the single shared observer at the bottom of this file)


// ===================== BREAK THE LINE FOR THE SUBSCRIPTION WIDGET DESCRIPTION ===================== //
(function () {

  function formatSealDescription(el) {
    if (!el) return;

    const text = el.textContent.trim();

    if (!text.includes('•')) return;

    const parts = text
      .split('•')
      .map(part => part.trim())
      .filter(Boolean);

    if (parts.length < 2) return;

    const formattedHTML = parts
      .map((part) => `<span class="seal-bullet-line">• ${part}</span>`)
      .join('<br>');

    // Don't rewrite if it is already formatted
    if (el.innerHTML === formattedHTML) return;

    el.innerHTML = formattedHTML;

  }


  function observeDescription(el) {

    // Format immediately
    formatSealDescription(el);

    // Watch only this description element
    const observer = new MutationObserver(() => {

      // Seal has changed/re-rendered the text
      requestAnimationFrame(() => {
        formatSealDescription(el);
      });

    });

    observer.observe(el, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }


  function findSealDescriptions() {

    document
      .querySelectorAll('.sls-selling-plan-description-content')
      .forEach((el) => {

        // Don't attach multiple observers
        if (el.dataset.descriptionObserver === 'true') return;

        el.dataset.descriptionObserver = 'true';

        observeDescription(el);

      });

  }


  // Initial check
  findSealDescriptions();


  // Watch for Seal creating/replacing the description (via the shared observer below)
  window.__bedaFindSealDescriptions = findSealDescriptions;

})();

// ===================== CHANGE SEAL "MONTH" TO "1 MONTH" ===================== //

function renameSealMonth() {
  document.querySelectorAll('.sls-selling-plan-group-options').forEach((group) => {

    // Change first dropdown option
    const firstOption = group.querySelector(
      'select[name="subs_interval"] option:first-child'
    );

    if (firstOption && firstOption.textContent.trim().toLowerCase() === 'month') {
      firstOption.textContent = '1 month';
    }

    // Change displayed label beside "Deliver every"
    const firstLabel = group.querySelector(
      '.sls-selling-plan-group-first-option'
    );

    if (firstLabel && firstLabel.textContent.trim().toLowerCase() === 'month') {
      firstLabel.textContent = '1 month';
    }

  });
}


// Run once
renameSealMonth();


// Seal can rebuild the widget, so watch for changes
// ===================== SINGLE SHARED OBSERVER ===================== //
// PERF: this file used to start 4 separate MutationObservers on <body> on EVERY page (homepage
// included), two of which ran document-wide querySelectorAll on every DOM change for the whole
// page life. One observer now batches all checks into at most one run per animation frame.
(function () {
  let scheduled = false;

  function runSealTasks() {
    scheduled = false;
    if (!hasDefaulted && !userInteracted) selectSubscribeByDefault();
    scheduleLabelRename();
    if (window.__bedaFindSealDescriptions) window.__bedaFindSealDescriptions();
    renameSealMonth();
  }

  const sealObserver = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(runSealTasks);
  });

  sealObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
})();